import { IChannelList } from "types/channels";
import { IDeviceList } from "types/device";
import { IMachineList } from "types/machine";
import { IPlacementList } from "types/placement";
import { ResponseType } from "types/response";
import { ISensorType } from "types/sensorType";

export enum EActions {
  setOpenModal = "setOpenModal",
  setMachine = "setMachine",
  setDevices = "setDevices",
  setPlacements = "setPlacements",
  setLoading = "setLoading",
  setSensorTypes = "setSensorTypes",
  setLoadingSensorTypes = "setLoadingSensorTypes",
  setChannels = "setChannels",
  setLoadingChannels = "setLoadingChannels",
  setAudioChunkTypes = "setAudioChunkTypes",
  setLoadingAudioChunkTypes = "setLoadingAudioChunkTypes",
}

export interface ICreateMachineList {
  type: EActions;
  payload: ICreateMachineState;
}

export interface ICreateMachineState {
  openModal: boolean;
  machine: IMachineList | null;
  devices: ResponseType<IDeviceList> | null;
  loading: boolean;
  placements: ResponseType<IPlacementList> | null;
  sensorTypes?: ResponseType<ISensorType> | null;
  loadingSensorTypes?: boolean;
  channels?: ResponseType<IChannelList> | null;
  loadingChannels?: boolean;
  audioChunkTypes?: ResponseType<any> | null;
  loadingAudioChunkTypes?: boolean;
}
